import { type ReactNode } from 'react';
import { TicketingAdminPanel } from './TicketingAdminPanel';
import { DemSettingsPage } from '../../pages/dem/DemSettingsPage';
import { useAdminHubContext } from '../../contexts/AdminHubContext';
import {
  canManageCrmConfigInAdminHub,
  canManageDemConfigInAdminHub,
  canManageItConfigInAdminHub,
} from '../../lib/adminHubPermissions';

function EmailTemplatesCategory({
  title,
  countLabel,
  children,
}: {
  title: string;
  countLabel: string;
  children: ReactNode;
}) {
  return (
    <section className="unified-users-dept">
      <header className="unified-users-dept__head">
        <h3 className="unified-users-dept__title">{title}</h3>
        <span className="unified-users-dept__count">{countLabel}</span>
      </header>
      {children}
    </section>
  );
}

export function EmailTemplatesAdminPanel() {
  const hubCtx = useAdminHubContext();
  const actorRole = hubCtx?.actorRole ?? 'user';
  const canTickets =
    canManageCrmConfigInAdminHub(actorRole) || canManageItConfigInAdminHub(actorRole);
  const canDem = canManageDemConfigInAdminHub(actorRole);

  if (!canTickets && !canDem) {
    return <p className="settings-empty">You cannot manage email templates.</p>;
  }

  const sectionCount = (canTickets ? 1 : 0) + (canDem ? 1 : 0);

  return (
    <section className="card settings-panel email-templates-admin">
      <div className="settings-panel__head unified-users-panel__head">
        <div className="unified-users-panel__title-row">
          <h2 className="settings-panel__title">Email Templates</h2>
          <div className="unified-users-panel__actions">
            <span className="settings-panel__count">
              {sectionCount} {sectionCount === 1 ? 'section' : 'sections'}
            </span>
          </div>
        </div>
      </div>

      <div className="unified-users-dept-list">
        {canTickets ? (
          <EmailTemplatesCategory title="Tickets" countLabel="Mailboxes & ticket emails">
            <TicketingAdminPanel embedded />
          </EmailTemplatesCategory>
        ) : null}

        {canDem ? (
          <EmailTemplatesCategory title="DEM" countLabel="2 order templates">
            <DemSettingsPage
              embeddedInAdminHub
              onlySection="templates"
              omitSectionChrome
            />
          </EmailTemplatesCategory>
        ) : null}
      </div>
    </section>
  );
}
